import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../assets/css/DigixLeads.css";
import "../assets/css/FinanceManagement.css";
import AccountsPayable from "./AccountsPayable";
import AccountsReceivable from "./AccountsReceivable";
import FinanceAccounts from "./FinanceAccounts";

export const TAB_ACCOUNTS_PAYABLE = "Accounts receivable";
export const TAB_ACCOUNTS_RECEIVABLE = "Accounts payable";
export const TAB_FINANCE_ACCOUNTS = "Company Accounts";

function tabFromRouteState(financeTab) {
  if (financeTab === "receivable") return TAB_ACCOUNTS_RECEIVABLE;
  if (financeTab === "accounts") return TAB_FINANCE_ACCOUNTS;
  return TAB_ACCOUNTS_PAYABLE;
}

function FinanceManagement() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() =>
    tabFromRouteState(location.state?.financeTab)
  );

  useEffect(() => {
    const financeTab = location.state?.financeTab;
    if (financeTab === "payable" || financeTab === "receivable" || financeTab === "accounts") {
      setActiveTab(tabFromRouteState(financeTab));
    }
  }, [location.state?.financeTab, location.key]);

  return (
    <div className="digixleads-container finance-management-page">
      <div className="main-card">
        <div className="page-header">
          <div className="page-header-row">
            <div className="tabs-container">
              <button
                type="button"
                className={`tab-button ${activeTab === TAB_ACCOUNTS_PAYABLE ? "active" : ""}`}
                onClick={() => setActiveTab(TAB_ACCOUNTS_PAYABLE)}
              >
                Accounts receivable
              </button>
              <button
                type="button"
                className={`tab-button ${activeTab === TAB_ACCOUNTS_RECEIVABLE ? "active" : ""}`}
                onClick={() => setActiveTab(TAB_ACCOUNTS_RECEIVABLE)}
              >
                Accounts payable
              </button>
              <button
                type="button"
                className={`tab-button ${activeTab === TAB_FINANCE_ACCOUNTS ? "active" : ""}`}
                onClick={() => setActiveTab(TAB_FINANCE_ACCOUNTS)}
              >
                Company Accounts
              </button>
            </div>
          </div>
        </div>

        <div className="finance-management-tab-body">
          {activeTab === TAB_ACCOUNTS_PAYABLE && <AccountsReceivable />}
          {activeTab === TAB_ACCOUNTS_RECEIVABLE && <AccountsPayable />}
          {activeTab === TAB_FINANCE_ACCOUNTS && <FinanceAccounts />}
        </div>
      </div>
    </div>
  );
}

export default FinanceManagement;
